export default {
    url: 'delta-3-max-plus-portable-power-station',
    include: ['us', 'ca'],
};
